<template>
  <v-container v-if="isAuthenticated" class="ml-2 mr-2">
    <v-row>
      <v-col cols="2">
        <v-btn @click="showDialog = true">Add New Term</v-btn><br><br>
        <v-checkbox v-model="showDisabled" label="Disabled" density="compact"></v-checkbox>
        <v-list class="bordered-list" height="1000px"> 
        <v-list-item
          v-for="(term, key) in filteredTerms" :key="key"
          @click="loadTerm(key)" 
        >
        <v-list-item-title style="display: flex; justify-content: space-between; align-items: center;">
        <span>{{ term.term }}</span>
        <span style="display: flex; justify-content: flex-end;">
          <v-icon v-if="term.enabled" class="ml-2" size="small">mdi-check-circle</v-icon>
          <v-icon v-if="term.video" class="ml-2" size="small">mdi-video</v-icon>
          <v-icon v-if="term.ttsLink" class="ml-2" size="small">mdi-volume-high</v-icon>
        </span>
      </v-list-item-title>
        </v-list-item>
      </v-list>
      </v-col>
      <v-col cols="8">
        <h1 @click="copyToClipboard" style="cursor: pointer;">{{ selectedTerm.term }} </h1><br>
        <v-card style="max-width: 1000px;">
          <v-card-title>Overview</v-card-title>
          <v-card-text>
            <quill-editor v-model:value="editorData" :options="editorOptions"></quill-editor>
          </v-card-text>
        </v-card>

        <v-card style="max-width: 1000px;">
          <v-card-title>Key Details</v-card-title>
          <v-card-text>
            <quill-editor v-model:value="editorData2" :options="editorOptions" class="custom-quill-editor"></quill-editor>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="2">
        <v-card width="400px">
          <v-card-title>Term Settings</v-card-title>
          <v-card-text>
            <v-switch
              v-model="selectedTerm.enabled"
              label="Enabled"
              color="primary"
            ></v-switch>
            <hr class="mt-4 mb-4">
            <v-text-field
              v-model="pronunciation"
              label="Pronunciation"
              variant="solo"
              density="compact"
            ></v-text-field>
            
            <v-text-field
              v-model="selectedTerm.ttsLink"
              label="TTS Link"
              variant="solo"
              density="compact"              
            ></v-text-field>      
            <audio ref="audioPlayer" style="display: none;"></audio>
            <v-btn @click="playAudio">Play</v-btn>&nbsp;      
            <v-btn @click="uploadAudioToFirebase">Download MP3</v-btn>&nbsp;
            <hr class="mt-4 mb-4">
            <v-text-field
              v-model="selectedTerm.video"
              label="Video"
              variant="solo"
              density="compact"              
            ></v-text-field>
            <hr class="mt-4 mb-4">
            <v-btn @click="pasteFromClipboard">Paste Markdown</v-btn>
            <v-btn @click="pasteFromClipboard2">Paste Seperate</v-btn>
            <v-btn @click="writeAndListenForResponse">GPT</v-btn>                        
            <hr class="mt-4 mb-4">
            <v-btn @click="openYouTubeSearch">YouTube</v-btn>
            <v-btn @click="openYouTubeDialog">YouTube Search</v-btn>            
            <hr class="mt-4 mb-4">
            <v-btn @click="saveTerm">Save</v-btn>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Add New Term</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="newTermName"
              label="Term Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="newTermDoc"
              label="Term Doc"
              required
            ></v-text-field>        
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="addNewTerm">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="youtubeDialog" max-width="800px">
      <v-card>
        <v-card-title>
          YouTube Search Results for "{{ selectedTerm.term }}"
        </v-card-title>
        <div class="floating-buttons">          
          <v-btn @click="loadPreviousPage" :disabled="!prevPageToken">Previous</v-btn>
          <v-btn @click="loadNextPage" :disabled="!pageToken">Next</v-btn>
        </div>             
        <v-card-text class="scrollable-content">
          <v-list>
            <v-list-item v-for="(video, index) in videos" :key="index">
              <v-list-item-avatar>
                <img :src="video.snippet.thumbnails.default.url" alt="thumbnail" @click="openYouTubeVideo(video.id.videoId)" style="cursor: pointer;">
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title @click="selectedVideo(video.id.videoId)" style="cursor: pointer;">{{ video.snippet.channelTitle }} - {{ video.snippet.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ video.snippet.description }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-divider v-if="index < videos.length - 1" class="mt-2 mb-2"></v-divider>              
            </v-list-item>
          </v-list>
        </v-card-text>
        <div class="floating-buttons">          
        </div>        
        <v-card-actions>
          <v-btn color="primary" @click="youtubeDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-container>
  <v-container v-else>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Login</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="loginPopup">
              <v-text-field
                v-model="email"
                label="Email"
                type="email"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                required
              ></v-text-field>
              <v-btn type="submit" color="primary">Login</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    
  </v-container>  
</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import { quillEditor } from 'vue3-quill';
import 'quill/dist/quill.snow.css'; // Import Quill styles
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { marked } from 'marked';
import { getAuth, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, getAdditionalUserInfo } from "firebase/auth";
import { addDoc, onSnapshot, collection } from "firebase/firestore";
import { db } from '@/firebaseConfig';
const auth = getAuth();

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      isAuthenticated: false,
      email: '',
      showDialog: false,
      newTermName: '',
      newTermDoc: '',
      password: '',
      loading: true,
      pronunciation: '',
      ttsLink: '',
      documentId: '',
      document: {
        field1: '',
        field2: '',
        richTextField: ''
      },
      terms: {},
      selectedTerm: {},
      editorData: '<p>Overview data...</p>',
      editorData2: '<p>Key details data...</p>',
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline'],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          ['image', 'code-block', 'link'],
          [{ 'indent': '-1' }, { 'indent': '+1' }] 
          ]
        }
      },
      youtubeDialog: false,
      videos: [],
      page: 1,
      totalPages: 0,
      apiKey: 'AIzaSyB-UJ2mx4hng84ye-HmZyLj1mg7JpQzQiY', // Replace with your YouTube API key
      pageToken: '',  
      prevPageToken: '',    
      showDisabled: false,      
    };
  },
  async mounted() {
    const store = useMainStore();
    //await store.fetchTerms(); // Adjust according to your store action
    this.terms = store.terms;
    //this.loading = false;

  },  
  methods: {    
    async login() {

      signInWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          // Signed in 
          const user = userCredential.user;
          console.log("Signed in as:", user);
          // ...
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode, errorMessage);
        });

    },    
    async loginPopup() {
      try {
        const result = await signInWithPopup(auth,  new GoogleAuthProvider());
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        const details = getAdditionalUserInfo(result);
        console.log(details)


        var isNewUser = details.isNewUser;
          if (isNewUser) {
               //delete the created user
               result.user.delete();
               console.error("Access denied: Unauthorized new user:", user);
               alert("Access denied: Unauthorized new user");
          } else {
               // your sign in flow
               console.log("User signed in: ", user, token);
          }        
        
      } catch (error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email || 'N/A'; // Use error.email directly
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        console.error("Error signing in: ", errorCode, errorMessage, email, credential);
      }


    },     
    loadTerm(key) {  
      const term = this.terms[key];
      console.log(key); // Log the key name

      this.selectedTerm = JSON.parse(JSON.stringify(term));
      this.selectedTerm.name = key
      this.pronunciation = this.selectedTerm.term
      this.editorData = this.selectedTerm.definition;
      this.editorData2 = this.selectedTerm.keydetails;
      this.pageToken = '';

      /*   
            this.selectedTerm = term;

            // Clear pronunciation, ttslink, and video if they do not exist or are empty
      this.pronunciation = term.pronunciation || '';
    */
    },
    async pasteFromClipboard2() {
      try {
        const text = await navigator.clipboard.readText();

        //const overviewRegex = /### Overview([\s\S]*?)### Key Details/;
        const overviewRegex = /### Overview[\s\S]*?\n([\s\S]*?)\n### Key Details/;

        //const keyDetailsRegex = /### Key Details([\s\S]*)/;
        const keyDetailsRegex = /### Key Details[\s\S]*?\n([\s\S]*)/;

        
        const overviewMatch = overviewRegex.exec(text);
        const keyDetailsMatch = keyDetailsRegex.exec(text);


        
        let overview = '';
        let keyDetails = '';
        
        if (overviewMatch) {
          overview = overviewMatch[1].trim().replace(/[\r\n]+/g, ' ');
        }
        
        if (keyDetailsMatch) {
          keyDetails = keyDetailsMatch[1].trim();
          // Check for "- **Mechanics" and replace the line
          keyDetails = keyDetails.replace(/- \*\*Mechanics.*\*\*:/, '### Mechanics:');
        } 
        /*
        if (keyDetailsMatch) {
          keyDetails = keyDetailsMatch[1].trim();
        }
        */


        const html1 = marked(overview); // Transform Markdown to HTML                
        this.editorData += html1; // Assuming you want to append the clipboard text to the editor

        const html2 = marked(keyDetails); // Transform Markdown to HTML                
        this.editorData2 += html2; // Assuming you want to append the clipboard text to the editor

      } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
      }
    }, 
    async pasteFromClipboard() {
      try {
        const text = await navigator.clipboard.readText();
        const html = marked(text); // Transform Markdown to HTML                
        this.editorData2 += html; // Assuming you want to append the clipboard text to the editor
      } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
      }
    },         
    async downloadMp3() {
    },    
    async playAudio() {
      const text = this.pronunciation;
      const apiKey = 'AIzaSyAYa50tWimWqtYUwrlMO1EJQguVlLSm9Qo';
      const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`;

      const requestBody = {
        input: { text: text },
        voice: { languageCode: 'en-US', ssmlGender: 'NEUTRAL' },
        audioConfig: { audioEncoding: 'MP3' },
      };

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        const audioContent = data.audioContent;
        const audioPlayer = this.$refs.audioPlayer;
        audioPlayer.src = `data:audio/mp3;base64,${audioContent}`;
        audioPlayer.style.display = 'block';
        audioPlayer.play();
      } catch (error) {
        console.error('Error:', error);
      }
    },        
    async uploadAudioToFirebase() {
      const text = this.pronunciation;
      const apiKey = 'AIzaSyAYa50tWimWqtYUwrlMO1EJQguVlLSm9Qo';
      const url = `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`;

      const requestBody = {
        input: { text: text },
        voice: { languageCode: 'en-US', ssmlGender: 'NEUTRAL' },
        audioConfig: { audioEncoding: 'MP3' },
      };

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        const audioContent = data.audioContent;

        // Convert base64 to Blob
        const byteCharacters = atob(audioContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'audio/mp3' });

        const uniqueFileName = `${text}-${Math.floor(Math.random() * 1000000)}.mp3`;

        // Upload to Firebase Storage
        const storage = getStorage();
        const storageRef = ref(storage, `audio/${uniqueFileName}`);
        await uploadBytes(storageRef, blob);

        // Get the download URL
        const downloadURL = await getDownloadURL(storageRef);
        console.log('File available at', downloadURL);
        this.selectedTerm.ttsLink = downloadURL;
      } catch (error) {
        console.error('Error:', error);
      }
    },  
    async saveTerm() {
      this.selectedTerm.definition = this.editorData
      this.selectedTerm.keydetails = this.editorData2

      if (this.selectedTerm.video && this.selectedTerm.video.includes('.com')) {
        const url = new URL(this.selectedTerm.video);
        const videoId = url.searchParams.get('v');
        if (videoId) {
          this.selectedTerm.video = videoId;
        }
      }

      const store = useMainStore();
      await store.saveTerm(this.selectedTerm);
      await store.fetchTerms(); // Adjust according to your store action
      this.terms = store.terms;
    },
    async addNewTerm() {
      if (this.newTermName.trim() === '' || this.newTermDoc.trim() === '') {
        alert('Term Name is required');
        return;
      }

      const termExists = Object.values(this.terms).some(term => term.name === this.newTermDoc);

      if (termExists) {
        alert('Term Name already exists');
        return;
      }      

      const store = useMainStore();
      await store.addNewTerm(this.newTermName, this.newTermDoc);
      await this.delay(2000); 
      this.terms = store.terms;
      this.showDialog = false;
      this.newTermName = '';
      this.newTermDoc = '';

    },       
    delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
    },    
    openYouTubeSearch() {
    const searchQuery = "bjj " + this.selectedTerm.term;
    const url = `https://www.youtube.com/results?search_query=${encodeURIComponent(searchQuery)}`;
    window.open(url, '_blank');
  },      
  copyToClipboard() {
      navigator.clipboard.writeText(this.selectedTerm.term)
        .then(() => {
          console.log('Text copied to clipboard');
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    },
    async fetchYouTubeResults() {
      try {
        const term = "bjj " + this.selectedTerm.term;
        const maxResults = 10;
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${term}&type=video&maxResults=${maxResults}&key=${this.apiKey}&pageToken=${this.pageToken}`
        );
        const data = await response.json();
        
        if (data.items && data.pageInfo) {
          this.videos = data.items;
          this.totalPages = Math.ceil(data.pageInfo.totalResults / maxResults);
          this.pageToken = data.nextPageToken || '';
          this.prevPageToken = data.prevPageToken || '';
        } else {
          console.error('Unexpected API response structure:', data);
        }
      } catch (error) {
        console.error('Error fetching YouTube results:', error);
      }
    },
    openYouTubeDialog() {
      this.youtubeDialog = true;
      this.fetchYouTubeResults();
    },       
    selectedVideo(videoId) {
      this.selectedTerm.video = videoId;
      this.youtubeDialog = false;
    },
    openYouTubeVideo(videoId) {
      const url = `https://www.youtube.com/watch?v=${videoId}`;
      window.open(url, '_blank');
    },     
    async loadNextPage() {
    if (this.pageToken) {
      await this.fetchYouTubeResults();
    }
  },
  async loadPreviousPage() {
    if (this.prevPageToken) {
      this.pageToken = this.prevPageToken;
      await this.fetchYouTubeResults();
    }
  }, 
  async writeAndListenForResponse() {
    const gptprompt = "Explain the jiu jitsu (bjj) term '" + this.selectedTerm.term + "'. Begin with an **'Overview:'** section that provides a general explanation. Follow this with a **'Key Details:'** section that includes in-depth information, bullet points, and structured subheadings as necessary. Ensure that the 'Key Details:' section is as DETAILED as possible for you and covers all relevant aspects to give a thorough understanding of the topic. 'Key Details' subheadings should also be as detailed as possible. End with a summary paragraph. Repsond in HTML format for quill editor. Use all of your token space for a response."
    //const gptprompt = "Explain the jiu jitsu (bjj) term '" + this.selectedTerm.term + "'. Includes in-depth information, bullet points, and structured subheadings as necessary. Ensure that it is as DETAILED as possible and covers all relevant aspects to give a thorough understanding of the topic. Subheadings should also be as detailed as possible. End with a summary paragraph. Repsond in HTML format for quill editor. Use all of your token space for a response."    
    const collectionRef = collection(db, "gpt/admin/messages");

    // Write the document to Firestore with an auto-generated ID
    const docRef = await addDoc(collectionRef,  { prompt: gptprompt });
    console.log("Document written with ID: ", docRef.id);
    alert("Document written with ID: ", docRef.id);
    // Set up a timeout to stop listening after 15 seconds
    const timeout = 15000; // 15 seconds
    let timeoutId;

    // Set up a listener to watch for changes to the document
    const unsubscribe = onSnapshot(docRef, (doc) => {
      const data = doc.data();
      if (data && data.response) {
        this.editorData2 += data.response;
        unsubscribe();
        clearTimeout(timeoutId);
      }
    });

    // Set up the timeout
    timeoutId = setTimeout(() => {
      unsubscribe();
    }, timeout);
    },  

  },
  watch: {
    newTermName(newVal) {
      this.newTermDoc = newVal.replace(/\s+/g, '-');
    },

  },  
  computed: {
    filteredTerms() {
      const termsEntries = Object.entries(this.terms);
      const filteredEntries = this.showDisabled
        ? termsEntries.filter(([, term]) => !term.enabled) // Remove 'key' from destructuring
        : termsEntries;
      return Object.fromEntries(filteredEntries);
  },  
},
  created() {
    auth.onAuthStateChanged(user => {
      //console.log("auth state change:",user)
      this.isAuthenticated = !!user;
    });
  }
};
</script>

<style scoped>
/* Custom font for Quill editor */
.ql-container {
  font-family: sans-serif !important;
  font-size: 1.1em;
}

.floating-buttons {
  position: sticky;
  top: 0; /* Adjust this value to control vertical position */
  background-color: lightblue; /* Example styling */
  padding: 10px;
}

.scrollable-content {
  max-height: 700px; /* Adjust the height as needed */
  overflow-y: auto;
  position: relative; /* Ensure relative positioning for floating buttons */
}

.custom-quill-editor {
  max-height: 600px; /* Set your desired maximum height */
  overflow-y: auto; /* Add scroll if content exceeds max height */
}
</style>